import { Typography, styled } from '@mui/material';
import { TableCell } from 'further-ui/components/Table';
import type { PcapPeriodResult } from './types';

const PeriodHeaderBottomCell = styled(TableCell)(({ theme }) => ({
  borderTop: 'none',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  borderLeft: 'none',
  borderRight: 'none',
  verticalAlign: 'bottom',
  paddingBottom: theme.spacing(theme.spacingSizes.sm),
}));

const PeriodHeaderText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  display: 'block',
  fontSize: '12px !important',
  lineHeight: 1.25,
}));

type Props = {
  title: string;
  period: PcapPeriodResult;
};

export default function PeriodHeaderCell({ title, period }: Props) {
  return (
    <PeriodHeaderBottomCell isHeaderCell size="small">
      <PeriodHeaderText variant="inherit">{title}</PeriodHeaderText>
      <PeriodHeaderText variant="inherit">
        ({period.periodStart.toReadable()} – {period.periodEnd.toReadable()})
      </PeriodHeaderText>
    </PeriodHeaderBottomCell>
  );
}
